export const PhilippinesProvinceOptions = [
  { value: "Metro Manila", label: "Metro Manila (NCR)" },
  { value: "Abra", label: "Abra" },
  { value: "Agusan del Norte", label: "Agusan del Norte" },
  { value: "Agusan del Sur", label: "Agusan del Sur" },
  { value: "Aklan", label: "Aklan" },
  { value: "Albay", label: "Albay" },
  { value: "Antique", label: "Antique" },
  { value: "Apayao", label: "Apayao" },
  { value: "Aurora", label: "Aurora" },
  { value: "Basilan", label: "Basilan" },
  { value: "Bataan", label: "Bataan" },
  { value: "Batanes", label: "Batanes" },
  { value: "Batangas", label: "Batangas" },
  { value: "Benguet", label: "Benguet" },
  { value: "Biliran", label: "Biliran" },
  { value: "Bohol", label: "Bohol" },
  { value: "Bukidnon", label: "Bukidnon" },
  { value: "Bulacan", label: "Bulacan" },
  { value: "Cagayan", label: "Cagayan" },
  { value: "Camarines Norte", label: "Camarines Norte" },
  { value: "Camarines Sur", label: "Camarines Sur" },
  { value: "Camiguin", label: "Camiguin" },
  { value: "Capiz", label: "Capiz" },
  { value: "Catanduanes", label: "Catanduanes" },
  { value: "Cavite", label: "Cavite" },
  { value: "Cebu", label: "Cebu" },
  { value: "Cotabato", label: "Cotabato" },
  { value: "Davao de Oro", label: "Davao de Oro" },
  { value: "Davao del Norte", label: "Davao del Norte" },
  { value: "Davao del Sur", label: "Davao del Sur" },
  { value: "Davao Occidental", label: "Davao Occidental" },
  { value: "Davao Oriental", label: "Davao Oriental" },
  { value: "Dinagat Islands", label: "Dinagat Islands" },
  { value: "Eastern Samar", label: "Eastern Samar" },
  { value: "Guimaras", label: "Guimaras" },
  { value: "Ifugao", label: "Ifugao" },
  { value: "Ilocos Norte", label: "Ilocos Norte" },
  { value: "Ilocos Sur", label: "Ilocos Sur" },
  { value: "Iloilo", label: "Iloilo" },
  { value: "Isabela", label: "Isabela" },
  { value: "Kalinga", label: "Kalinga" },
  { value: "La Union", label: "La Union" },
  { value: "Laguna", label: "Laguna" },
  { value: "Lanao del Norte", label: "Lanao del Norte" },
  { value: "Lanao del Sur", label: "Lanao del Sur" },
  { value: "Leyte", label: "Leyte" },
  { value: "Maguindanao del Norte", label: "Maguindanao del Norte" },
  { value: "Maguindanao del Sur", label: "Maguindanao del Sur" },
  { value: "Marinduque", label: "Marinduque" },
  { value: "Masbate", label: "Masbate" },
  { value: "Misamis Occidental", label: "Misamis Occidental" },
  { value: "Misamis Oriental", label: "Misamis Oriental" },
  { value: "Mountain Province", label: "Mountain Province" },
  { value: "Negros Occidental", label: "Negros Occidental" },
  { value: "Negros Oriental", label: "Negros Oriental" },
  { value: "Northern Samar", label: "Northern Samar" },
  { value: "Nueva Ecija", label: "Nueva Ecija" },
  { value: "Nueva Vizcaya", label: "Nueva Vizcaya" },
  { value: "Occidental Mindoro", label: "Occidental Mindoro" },
  { value: "Oriental Mindoro", label: "Oriental Mindoro" },
  { value: "Palawan", label: "Palawan" },
  { value: "Pampanga", label: "Pampanga" },
  { value: "Pangasinan", label: "Pangasinan" },
  { value: "Quezon", label: "Quezon" },
  { value: "Quirino", label: "Quirino" },
  { value: "Rizal", label: "Rizal" },
  { value: "Romblon", label: "Romblon" },
  { value: "Samar", label: "Samar" },
  { value: "Sarangani", label: "Sarangani" },
  { value: "Siquijor", label: "Siquijor" },
  { value: "Sorsogon", label: "Sorsogon" },
  { value: "South Cotabato", label: "South Cotabato" },
  { value: "Southern Leyte", label: "Southern Leyte" },
  { value: "Sultan Kudarat", label: "Sultan Kudarat" },
  { value: "Sulu", label: "Sulu" },
  { value: "Surigao del Norte", label: "Surigao del Norte" },
  { value: "Surigao del Sur", label: "Surigao del Sur" },
  { value: "Tarlac", label: "Tarlac" },
  { value: "Tawi-Tawi", label: "Tawi-Tawi" },
  { value: "Zambales", label: "Zambales" },
  { value: "Zamboanga del Norte", label: "Zamboanga del Norte" },
  { value: "Zamboanga del Sur", label: "Zamboanga del Sur" },
  { value: "Zamboanga Sibugay", label: "Zamboanga Sibugay" },
];

export const CountryOptions = [
  { value: "US", label: "United States" },
  { value: "PH", label: "Philippines" },
];

export const StateOptions = [
  { value: "Alabama", label: "Alabama (AL)" },
  { value: "Alaska", label: "Alaska (AK)" },
  { value: "Arizona", label: "Arizona (AZ)" },
  { value: "Arkansas", label: "Arkansas (AR)" },
  { value: "California", label: "California (CA)" },
  { value: "Colorado", label: "Colorado (CO)" },
  { value: "Connecticut", label: "Connecticut (CT)" },
  { value: "Delaware", label: "Delaware (DE)" },
  { value: "Florida", label: "Florida (FL)" },
  { value: "Georgia", label: "Georgia (GA)" },
  { value: "Hawaii", label: "Hawaii (HI)" },
  { value: "Idaho", label: "Idaho (ID)" },
  { value: "Illinois", label: "Illinois (IL)" },
  { value: "Indiana", label: "Indiana (IN)" },
  { value: "Iowa", label: "Iowa (IA)" },
  { value: "Kansas", label: "Kansas (KS)" },
  { value: "Kentucky", label: "Kentucky (KY)" },
  { value: "Louisiana", label: "Louisiana (LA)" },
  { value: "Maine", label: "Maine (ME)" },
  { value: "Maryland", label: "Maryland (MD)" },
  { value: "Massachusetts", label: "Massachusetts (MA)" },
  { value: "Michigan", label: "Michigan (MI)" },
  { value: "Minnesota", label: "Minnesota (MN)" },
  { value: "Mississippi", label: "Mississippi (MS)" },
  { value: "Missouri", label: "Missouri (MO)" },
  { value: "Montana", label: "Montana (MT)" },
  { value: "Nebraska", label: "Nebraska (NE)" },
  { value: "Nevada", label: "Nevada (NV)" },
  { value: "New Hampshire", label: "New Hampshire (NH)" },
  { value: "New Jersey", label: "New Jersey (NJ)" },
  { value: "New Mexico", label: "New Mexico (NM)" },
  { value: "New York", label: "New York (NY)" },
  { value: "North Carolina", label: "North Carolina (NC)" },
  { value: "North Dakota", label: "North Dakota (ND)" },
  { value: "Ohio", label: "Ohio (OH)" },
  { value: "Oklahoma", label: "Oklahoma (OK)" },
  { value: "Oregon", label: "Oregon (OR)" },
  { value: "Pennsylvania", label: "Pennsylvania (PA)" },
  { value: "Rhode Island", label: "Rhode Island (RI)" },
  { value: "South Carolina", label: "South Carolina (SC)" },
  { value: "South Dakota", label: "South Dakota (SD)" },
  { value: "Tennessee", label: "Tennessee (TN)" },
  { value: "Texas", label: "Texas (TX)" },
  { value: "Utah", label: "Utah (UT)" },
  { value: "Vermont", label: "Vermont (VT)" },
  { value: "Virginia", label: "Virginia (VA)" },
  { value: "Washington", label: "Washington (WA)" },
  { value: "West Virginia", label: "West Virginia (WV)" },
  { value: "Wisconsin", label: "Wisconsin (WI)" },
  { value: "Wyoming", label: "Wyoming (WY)" },
];
